module.exports = (status = {}) => {
  if (!status.items || !status.items) return null;
  const pdfItems = status.items.filter(i => i.has_file);
  if (pdfItems.length) {
    const personalPdf = pdfItems.find(i => !i.collection_shared);
    return personalPdf || pdfItems[0];
  }
  const personalRef = status.items.find(i => !i.collection_shared);
  return personalRef || status.items[0];
};
